



































































import {
    State,
    Action,
    Getter,
    Mutation
} from "vuex-class";
import {
    Component,
    Vue,
    Prop,
    Watch
} from "vue-property-decorator";
import {
    pageDataType,
    componentDataType
} from "../types";
import {
    TimelineMax,
    TweenLite,
    TweenMax,
    Power1,
    Expo,
    Power2,
    Power4
} from "gsap";
import {
    HOST
} from "../global";
import NewsDetailsText from '../components/NewsDetailsText.vue';
@Component({
    name: "NewsAndUpdateDetailPage",
    components: {
        NewsDetailsText
    }
})
export default class NewsAndUpdateDetailPage extends Vue {
    @Getter("pageData") public pageData!: pageDataType;
    public HOST: string = HOST;
    public smbanneranim(): void {
        const {
            imgoverlay
        } = this.$refs;
        TweenLite.delayedCall(2, overlay);

        function overlay() {
            TweenMax.to(imgoverlay, 0.3, {
                opacity: 0.6,
                ease: Power4.easeOut
            });
        }

        var smbanneranim = new TimelineMax({});

        smbanneranim
            .to(imgoverlay, 0.01, {
                opacity: 0
            })

            .staggerFrom(
                ".smbanner-container img",
                1, {
                    delay: 1.5,
                    autoAlpha: 0,
                    scale: 0.9,
                    ease: Power2.easeOut,
                    clearProps: "all"
                },
                0.05, '-=.5'
            )

            .staggerFrom(
                ".smbanner-text h1",
                0.6, {
                    autoAlpha: 0,
                    yPercent: 40,
                    ease: Power2.easeInOut,
                    clearProps: "all"
                },
                0.02, '-=.5'
            )
            .staggerFrom(
                ".smbanner-text .sm-title",
                0.6, {
                    autoAlpha: 0,
                    yPercent: 40,
                    ease: Power2.easeInOut,
                    clearProps: "all"
                },
                0.3, '-=.5'
            );
    }
    public mounted() {
        this.smbanneranim();
    }
}
